import { Injectable, NgZone } from '@angular/core';
import { LoadingController } from 'ionic-angular';
import { HttpClient, HttpHeaders  } from '@angular/common/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/timeout';

@Injectable()
export class HttpService {

	// static get parameters() {
	// 	return [[HttpClient]];
	// }

	// serverAddr:string;

	constructor(
		private http: HttpClient,
		public loadingCtrl: LoadingController,
		private zone: NgZone
	) {
	}

	get(url){
		return new Promise((resolve,reject)=>{
			console.log("url:"+url);
			let serverAddr = localStorage.getItem("HTTPService");
			let serverUrl = serverAddr+url;

			this.http.get(serverUrl).subscribe((res:any)=>{
				this.zone.run(() => resolve(res));
			},(err)=>{
				this.zone.run(() => reject(err));
			});
		});
	}

	post(url, body){
		return new Promise((resolve,reject)=>{
			// let loader = this.loadingCtrl.create({
			// 	content: "loading..."
			// });
			// loader.present();
			let serverAddr = localStorage.getItem("HTTPService");
			let serverUrl = serverAddr+url;

			let headers = new HttpHeaders({'Content-type': 'application/json'});

			console.log("[POST]", serverUrl, "body:", body);

			// timeout()이 zone.js가 패치하기 전의 타이머 레퍼런스를 캡슐화하는 경우가 있어
			// subscribe 콜백이 Angular zone 밖에서 실행될 수 있음 - zone.run()으로 강제 복귀시켜
			// resolve 이후 change detection이 확실히 도는 것을 보장한다.
			this.http.post(serverUrl, body, {headers:headers}).timeout(6000).subscribe((res:any)=>{
				console.log("[POST][res]", serverUrl, res);
				this.zone.run(() => resolve(res));
				// loader.dismiss();
			},(err)=>{
				console.log("[POST][err]", serverUrl, err);
				// reject('잠시후 다시 시도하세요. <br> (만약 이 메세지가 계속 나올 시 관리자에게 문의바랍니다.)');
				this.zone.run(() => reject(err));
				// loader.dismiss();
			});
		});
	}

	post_floor(url, body){
		return new Promise((resolve,reject)=>{
			let serverAddr = localStorage.getItem("HTTPService");
			let serverUrl = serverAddr+url;

			let headers = new HttpHeaders({'Content-type': 'application/json'});

			console.log("[POST_FLOOR]", serverUrl, "body:", body);

			this.http.post(serverUrl, body, {headers:headers}).timeout(6000).subscribe((res:any)=>{
				console.log("[POST_FLOOR][res]", serverUrl, res);
				this.zone.run(() => resolve(res));
			},(err)=>{
				console.log("[POST_FLOOR][err]", serverUrl, err);
				this.zone.run(() => reject(err));
			});
		});
	}

	lang_post(url, body){
		return new Promise((resolve,reject)=>{
			let serverAddr = localStorage.getItem("lang_http");
			let serverUrl = serverAddr+url;
			
			let headers = new HttpHeaders({'Content-type': 'application/json'});
			
			this.http.post(serverUrl, body, {headers:headers}).subscribe((res:any)=>{
				resolve(res);
			},(err)=>{
				reject(err);
			});
		});
	}

	sendCountry(url, body){
		return new Promise((resolve,reject)=>{
			
			let headers = new HttpHeaders({'Content-type': 'application/json'});
			
			this.http.post(url, body, {headers:headers}).subscribe((res:any)=>{
				resolve(res);
			},(err)=>{
				reject(err);
			});
		});
    }
    
    sendphoto(url, body){
		return new Promise((resolve,reject)=>{
			
			let headers = new HttpHeaders({'Content-type': 'application/json'});
			
			this.http.post(url, body, {headers:headers}).subscribe((res:any)=>{
				resolve(res);
			},(err)=>{
				reject(err);
			});
		});
	}
	
}



// WEBPACK FOOTER //
// ./src/services/HttpService.ts